import axios from 'axios';
import { BABYFACE_URL } from '../../../lib/routes/Routes';
import { ERROR_RETRY } from '../../../lib/Error';

export const updateContactInfo = async ({
  id,
  contactName,
  mobile,
  zipcode,
  address,
  detailAddress,
  contactEmail,
}) => {
  try {
    const response = await axios.put(
      BABYFACE_URL.concat(`/order/${id}/contact-info`),
      {
        contactName,
        mobile,
        zipcode,
        address,
        detailAddress,
        contactEmail,
      },
    );
    return response.data;
  } catch (e) {
    alert(ERROR_RETRY);
  }
};
